import React, { useState, useEffect } from 'react'
import { supabase } from './lib/supabase'
import { monatsCleanup } from './lib/cleanup'
import { C } from './theme'
import vsLogo from './assets/vs-logo.png'
import Login from './components/Login'
import Board from './components/Board'
import Statistik from './components/Statistik'
import Leihwagen from './components/Leihwagen'
import Display from './components/Display'
import TabletView from './components/TabletView'
import Fahrzeugliste from './components/Fahrzeugliste'
import Einstellungen from './components/Einstellungen'
import Dashboard from './components/Dashboard'

const NAV = [
  { key: 'dashboard',      label: 'Dashboard',        icon: '🏠' },
  { key: 'board',          label: 'Werkstatt-Board',   icon: '📋' },
  { key: 'fahrzeuge',      label: 'Fahrzeuge',         icon: '🚗' },
  { key: 'leihwagen',      label: 'Leihwagen',         icon: '🔑' },
  { key: 'statistik',      label: 'Statistiken',       icon: '📊' },
  { key: 'tv',             label: 'TV-Modus',          icon: '📺' },
  { key: 'einstellungen',  label: 'Einstellungen',     icon: '⚙️' },
]

export default function App() {
  const [session, setSession]           = useState(null)
  const [userRole, setUserRole]         = useState('werkstatt')
  const [mitarbeiter, setMitarbeiter]   = useState('')
  const [benutzername, setBenutzername] = useState('')
  const [seite, setSeite]               = useState('dashboard')
  const [neuForm, setNeuForm]           = useState(false)
  const [neuData, setNeuData]           = useState({
    kennzeichen: '', marke: '', modell: '', farbe: '',
    kunde: '', telefon: '', fastcars: false, fastcars_notiz: '',
    leihwagen_id: '', mitarbeiter: '', wunschdatum: '',
  })
  const [leihwagenListe, setLeihwagenListe] = useState([])
  const [loading, setLoading]               = useState(false)
  const [isMobile, setIsMobile]             = useState(window.innerWidth < 768)
  const [sidebarOpen, setSidebarOpen]       = useState(false)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      if (session) ladeProfil(session.user.email)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
      if (session) ladeProfil(session.user.email)
    })
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', handleResize)
    return () => { subscription.unsubscribe(); window.removeEventListener('resize', handleResize) }
  }, [])

  useEffect(() => {
    if (session) {
      ladeLeihwagen()
      monatsCleanup()
    }
  }, [session])

  const ladeProfil = async (email) => {
    setMitarbeiter(email)
    const adminEmails = (process.env.REACT_APP_ADMIN_EMAILS || '').split(',')
    setUserRole(adminEmails.includes(email) ? 'admin' : 'werkstatt')
    const { data } = await supabase.from('benutzer').select('benutzername').eq('email', email).single()
    setBenutzername(data?.benutzername || email)
  }

  const ladeLeihwagen = async () => {
    const { data } = await supabase.from('leihwagen').select('*').eq('verfügbar', true)
    setLeihwagenListe(data || [])
  }

  const abmelden = async () => {
    await supabase.auth.signOut()
    setSession(null)
  }

  const fahrzeugHinzufuegen = async (e) => {
    e.preventDefault()
    if (!neuData.kennzeichen) return
    setLoading(true)

    const insert = { ...neuData }
    if (!insert.leihwagen_id) delete insert.leihwagen_id
    if (!insert.fastcars_notiz) delete insert.fastcars_notiz
    if (!insert.wunschdatum) delete insert.wunschdatum
    delete insert.mitarbeiter

    const { error } = await supabase.from('fahrzeuge').insert({ ...insert, schritt: 1 })

    if (!error && insert.leihwagen_id) {
      await supabase.from('leihwagen').update({ verfügbar: false, vergeben_an: insert.kunde }).eq('id', insert.leihwagen_id)
    }
    if (!error) {
      setNeuData({ kennzeichen: '', marke: '', modell: '', farbe: '', kunde: '', telefon: '', fastcars: false, fastcars_notiz: '', leihwagen_id: '', mitarbeiter: '' })
      setNeuForm(false)
      ladeLeihwagen()
    }
    setLoading(false)
  }

  const BASE = process.env.PUBLIC_URL || ''
  if (window.location.pathname === `${BASE}/display`) return <Display />
  if (window.location.pathname === `${BASE}/tablet`)  return <TabletView />
  if (!session) return <Login />

  const navTo = (key) => {
    if (key === 'tv') {
      window.open(`${BASE}/display`, '_blank')
      return
    }
    setSeite(key)
    setSidebarOpen(false)
  }

  const sidebarContent = (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ padding: '16px 14px 14px', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
        <div style={{ background: '#fff', borderRadius: 8, padding: '8px 10px', borderBottom: `3px solid ${C.primary}` }}>
          <img src={vsLogo} alt="VS Automobilzentrum" style={{ width: '100%', display: 'block' }} />
        </div>
        <div style={{ fontSize: 10, color: C.textFaint, marginTop: 7, textAlign: 'center', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 700 }}>Werkstatt-Board</div>
      </div>

      <nav style={{ flex: 1, padding: '8px 0', overflowY: 'auto' }}>
        {NAV.map(n => {
          const isActive = seite === n.key
          return (
            <button key={n.key} onClick={() => navTo(n.key)} style={{
              display: 'flex', alignItems: 'center', gap: 10,
              width: '100%', padding: '9px 16px',
              background: isActive ? C.primary : 'transparent',
              border: 'none', color: isActive ? C.onPrimary : '#9ca3af',
              cursor: 'pointer', fontSize: 13, fontWeight: 600,
              textAlign: 'left', transition: 'background 0.15s',
            }}>
              <span style={{ fontSize: 15, width: 20, textAlign: 'center' }}>{n.icon}</span>
              {n.label}
            </button>
          )
        })}

        <div style={{ padding: '8px 12px 0' }}>
            <button onClick={() => { setNeuForm(true); setSidebarOpen(false) }} style={{
              display: 'flex', alignItems: 'center', gap: 8, width: '100%',
              padding: '9px 12px', background: C.primary,
              border: 'none', borderRadius: 8,
              color: C.onPrimary, cursor: 'pointer', fontSize: 13, fontWeight: 800,
            }}>
              <span>+</span> Fahrzeug hinzufügen
            </button>
          </div>
      </nav>

      <div style={{ padding: '12px 16px', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          <div style={{ width: 30, height: 30, borderRadius: 50, background: '#374151', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, color: '#9ca3af', flexShrink: 0 }}>
            {benutzername ? benutzername[0].toUpperCase() : '?'}
          </div>
          <div style={{ overflow: 'hidden' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#e5e7eb', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{benutzername}</div>
            <div style={{ fontSize: 10, color: userRole === 'admin' ? C.primary : '#60a5fa' }}>{userRole === 'admin' ? 'Admin' : 'Mitarbeiter'}</div>
          </div>
        </div>
        <button onClick={abmelden} style={{ width: '100%', padding: '6px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 6, color: '#6b7280', cursor: 'pointer', fontSize: 12 }}>
          Abmelden
        </button>
      </div>
    </div>
  )

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: 'system-ui, sans-serif' }}>
      {isMobile ? (
        <>
          {sidebarOpen && (
            <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 199 }} onClick={() => setSidebarOpen(false)} />
          )}
          <aside style={{
            position: 'fixed', top: 0, left: sidebarOpen ? 0 : -210, bottom: 0,
            width: 210, background: C.dark, zIndex: 200,
            transition: 'left 0.22s ease', boxShadow: sidebarOpen ? '4px 0 20px rgba(0,0,0,0.4)' : 'none',
          }}>
            {sidebarContent}
          </aside>

          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '0 14px', height: 52, display: 'flex', alignItems: 'center', gap: 10, position: 'sticky', top: 0, zIndex: 100 }}>
              <button onClick={() => setSidebarOpen(o => !o)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#374151', padding: '0 4px', lineHeight: 1 }}>
                {sidebarOpen ? '✕' : '☰'}
              </button>
              <div style={{ flex: 1, position: 'relative' }}>
                <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', fontSize: 14, color: '#9ca3af', pointerEvents: 'none' }}>🔍</span>
                <input placeholder="Suchen (Kennzeichen, Kunde...)" style={{ width: '100%', padding: '7px 12px 7px 32px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, background: '#f9fafb', outline: 'none', boxSizing: 'border-box' }} />
              </div>
            </div>
            <main style={{ flex: 1, background: '#f3f4f6', overflowY: 'auto' }}>
              <PageContent seite={seite} userRole={userRole} mitarbeiter={mitarbeiter} isMobile={isMobile} navTo={navTo} />
            </main>
          </div>
        </>
      ) : (
        <>
          <aside style={{ width: 210, background: C.dark, flexShrink: 0, position: 'sticky', top: 0, height: '100vh', overflowY: 'auto' }}>
            {sidebarContent}
          </aside>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <div style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', padding: '0 24px', height: 52, display: 'flex', alignItems: 'center', gap: 14, position: 'sticky', top: 0, zIndex: 100 }}>
              <div style={{ flex: 1, maxWidth: 480, position: 'relative' }}>
                <span style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', fontSize: 14, color: '#9ca3af', pointerEvents: 'none' }}>🔍</span>
                <input placeholder="Suchen (Kennzeichen, Kunde...)" style={{ width: '100%', padding: '8px 14px 8px 34px', border: '1px solid #e5e7eb', borderRadius: 8, fontSize: 13, background: '#f9fafb', outline: 'none', boxSizing: 'border-box' }} />
              </div>
            </div>
            <main style={{ flex: 1, background: '#f3f4f6', overflowY: 'auto' }}>
              <PageContent seite={seite} userRole={userRole} mitarbeiter={mitarbeiter} isMobile={isMobile} navTo={navTo} />
            </main>
          </div>
        </>
      )}

      {neuForm && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <h3 style={{ margin: 0 }}>Neues Fahrzeug</h3>
              <button style={styles.closeBtn} onClick={() => setNeuForm(false)}>✕</button>
            </div>
            <form onSubmit={fahrzeugHinzufuegen}>
              <div style={styles.formGrid}>
                {[
                  { label: 'Kennzeichen *', key: 'kennzeichen', type: 'text' },
                  { label: 'Marke',         key: 'marke',       type: 'text' },
                  { label: 'Modell',        key: 'modell',      type: 'text' },
                  { label: 'Farbe',         key: 'farbe',       type: 'text' },
                  { label: 'Kunde',         key: 'kunde',       type: 'text' },
                  { label: 'Telefon',       key: 'telefon',     type: 'text' },
                ].map(f => (
                  <div key={f.key}>
                    <label style={styles.label}>{f.label}</label>
                    <input style={styles.input} type={f.type} value={neuData[f.key]}
                      onChange={e => setNeuData({ ...neuData, [f.key]: e.target.value })}
                      required={f.key === 'kennzeichen'} />
                  </div>
                ))}
                <div>
                  <label style={styles.label}>Leihwagen</label>
                  <select style={styles.input} value={neuData.leihwagen_id} onChange={e => setNeuData({ ...neuData, leihwagen_id: e.target.value })}>
                    <option value="">Kein Leihwagen</option>
                    {leihwagenListe.map(lw => (
                      <option key={lw.id} value={lw.id}>{lw.kennzeichen} {lw.modell}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={styles.label}>Wunschtermin</label>
                  <input type="date" style={styles.input} value={neuData.wunschdatum} onChange={e => setNeuData({ ...neuData, wunschdatum: e.target.value })} />
                </div>
              </div>
              <div style={{ marginTop: 12 }}>
                <label>
                  <input type="checkbox" checked={neuData.fastcars} onChange={e => setNeuData({ ...neuData, fastcars: e.target.checked })} />
                  {' '}Fastcars-Auftrag
                </label>
                {neuData.fastcars && (
                  <input style={{ ...styles.input, marginTop: 8, width: '100%', boxSizing: 'border-box' }}
                    placeholder="Fastcars Notiz..."
                    value={neuData.fastcars_notiz}
                    onChange={e => setNeuData({ ...neuData, fastcars_notiz: e.target.value })} />
                )}
              </div>
              <div style={styles.modalActions}>
                <button type="button" style={styles.cancelBtn} onClick={() => setNeuForm(false)}>Abbrechen</button>
                <button type="submit" style={styles.submitBtn} disabled={loading}>
                  {loading ? 'Speichern...' : 'Fahrzeug anlegen'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

function PageContent({ seite, userRole, mitarbeiter, isMobile, navTo }) {
  if (seite === 'dashboard')     return <Dashboard isMobile={isMobile} onNavigate={navTo} />
  if (seite === 'board')         return <Board userRole={userRole} mitarbeiter={mitarbeiter} isMobile={isMobile} />
  if (seite === 'fahrzeuge')     return <Fahrzeugliste isMobile={isMobile} />
  if (seite === 'statistik')     return <Statistik isMobile={isMobile} />
  if (seite === 'leihwagen')     return <Leihwagen userRole={userRole} isMobile={isMobile} />
  if (seite === 'einstellungen') return <Einstellungen userRole={userRole} />
  return null
}

const styles = {
  overlay:      { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300 },
  modal:        { background: '#fff', borderRadius: 12, padding: 28, width: '90%', maxWidth: 600, maxHeight: '90vh', overflowY: 'auto' },
  modalHeader:  { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 },
  closeBtn:     { background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#666' },
  formGrid:     { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
  label:        { display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#333' },
  input:        { width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' },
  modalActions: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 },
  cancelBtn:    { padding: '8px 20px', border: '1px solid #ddd', borderRadius: 8, background: '#fff', cursor: 'pointer', fontSize: 14 },
  submitBtn:    { padding: '8px 20px', background: '#ffc000', color: '#111111', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 800, fontSize: 14 },
}
